import {MNullable} from '../Toolkit/Utils';

export class AuditLog {
    public auditLogId: number = 0;
    public entryDate: MNullable<Date> = null;
    public userName: string = '';
    public auditActionTypeId: number = 0;
    public safeDigsId: number = 0;
    public notes: string = '';
}

export class AuditLogReply {
    public data: MNullable<AuditLog> = null;
}

export class AuditLogListReply {
    public data: AuditLog[] = [];
}